module.exports = __webpack_public_path__ + "static/Ammar-c6e077a6ac414aec47e61bd529a04b4c.png";